import React from 'react';
import { SupportButton } from '@shared/ui/support-button';
import s from './after-registration-teacher-page.module.scss';

export const AfterRegistrationTeacher = () => {
	return (
			<div className={s.wrapper}>
					<div className={s.card}>
							<h2 className={s.title}>
									Регистрация успешна
							</h2>
							<p className={s.message}>
									Спасибо за регистрацию! В ближайшее время с вами свяжется представитель нашего сервиса для договоренности о созвоне и дальнейших шагах.
							</p>
							<div className={s.register}>
									Если у вас возникнут вопросы или потребуется помощь, вы можете связаться с нами через <SupportButton label="контактную информацию" theme="clear" size="small" className={s.supportWrapper} buttonClassName={s.supportButton} />.
							</div>
					</div>
			</div>
	);
};
